import { SettingsForm } from '@/features/settings/components';
import { useTranslation } from 'react-i18next';
import { PageLayout } from '@/shared/components';

export function SettingsPage() {
  const { t } = useTranslation();
  return (
    <PageLayout title={t('settings.title')}>
      <SettingsForm />
    </PageLayout>
  );
}
